import type { Extras } from "@sentry/types";

import { getWindow } from "~/lib/utils";

export const getLocalstorageExtraInformation = (): Extras => {
  if (!getWindow()) return {};
  return Object.entries(localStorage).reduce((accumulator, [key, value]) => {
    accumulator[key] = new Blob([value]).size;
    return accumulator;
  }, {} as Extras);
};
